// import JSEncrypt from 'jsencrypt';

export default {
  methods: {
    convertQueryType(options = {}, fields = []) {
      const oldData = JSON.parse(JSON.stringify(options));
      const newData = JSON.parse(JSON.stringify(options));

      Object.keys(oldData).forEach((key) => {
        if (fields.some((val) => val === key)) {
          return;
        }
        if (/^[\d]+$/.test(oldData[key])) {
          newData[key] = parseInt(newData[key], 10);
        }
        if (/^[\d]?\.[\d]+$/.test(oldData[key])) {
          newData[key] = parseFloat(newData[key]);
        }

        if (/^true$/.test(oldData[key])) {
          newData[key] = true;
        }

        if (/^false$/.test(oldData[key])) {
          newData[key] = false;
        }
      });
      const queryForm = JSON.parse(JSON.stringify(newData));
      if (queryForm.pageNum) {
        delete queryForm.pageNum;
      }
      if (queryForm.currentPage) {
        delete queryForm.currentPage;
      }
      if (queryForm.pageSize) {
        delete queryForm.pageSize;
      }
      if (queryForm.total) {
        delete queryForm.total;
      }
      const pagination = { currentPage: newData.currentPage || 1, pageNum: newData.pageNum || 1 };
      if (newData.pageSize) {
        pagination.pageSize = newData.pageSize;
      }

      return { queryForm, pagination };
    },
  },
};
